import React from 'react';
import GeneralAim from './GeneralAim';
import '../../styles/aims/aims.css';

const About = () => {
	return (
		<div>
            <GeneralAim />
		</div>
	);
};

export default About;